import { render, staticRenderFns } from "./AddMenu.vue?vue&type=template&id=6801a978&scoped=true"
import script from "./AddMenu.vue?vue&type=script&lang=ts"
export * from "./AddMenu.vue?vue&type=script&lang=ts"
import style0 from "./AddMenu.vue?vue&type=style&index=0&id=6801a978&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6801a978",
  null
  
)

export default component.exports